module.exports = __webpack_public_path__ + "static/media/card (2).2c44222b.pdf";